// PostgreSQL stores quantities with 3 decimals and unit prices with 4.
// Work in decimal integers; round the product to cents, never the unit to cents.
function decimal(valor) {
    const texto = String(valor ?? '').trim().replace(',', '.');
    const partes = /^([+-]?)(\d*)(?:\.(\d*))?(?:e([+-]?\d+))?$/i.exec(texto);
    if (!partes || !(partes[2] || partes[3]) || !Number.isFinite(Number(texto))) {
        return { inteiro: 0n, casas: 0 };
    }
    let inteiro = BigInt((partes[2] || '0') + (partes[3] || ''));
    let casas = (partes[3] || '').length - Number(partes[4] || 0);
    if (casas < 0) {
        inteiro *= 10n ** BigInt(-casas);
        casas = 0;
    }
    return { inteiro: partes[1] === '-' ? -inteiro : inteiro, casas };
}

function ajustarCasas({ inteiro, casas }, destino) {
    if (casas <= destino) return inteiro * 10n ** BigInt(destino - casas);
    const divisor = 10n ** BigInt(casas - destino);
    const absoluto = inteiro < 0n ? -inteiro : inteiro;
    const arredondado = (absoluto + divisor / 2n) / divisor;
    return inteiro < 0n ? -arredondado : arredondado;
}

function formatarDecimal(inteiro, casas) {
    const absoluto = (inteiro < 0n ? -inteiro : inteiro).toString().padStart(casas + 1, '0');
    return (inteiro < 0n ? '-' : '') + absoluto.slice(0, -casas) + '.' + absoluto.slice(-casas);
}

export function formatarUnitario(valor) {
    if (valor == null || String(valor).trim() === '') return '';
    return formatarDecimal(ajustarCasas(decimal(valor), 4), 4).replace(/(\.\d{2,}?)0+$/, '$1');
}

export function totalLinha(qtd, unitario) {
    const quantidade = ajustarCasas(decimal(qtd), 3);
    const preco = ajustarCasas(decimal(unitario), 4);
    const centimos = ajustarCasas({ inteiro: quantidade * preco, casas: 7 }, 2);
    return formatarDecimal(centimos, 2);
}
